import { Modal, ModalWithTransition } from '@studiometa/ui';

/**
 * Panel Class.
 */
export default class LanguageModal extends ModalWithTransition {
  isOpen = false;

  static config = {
    name: 'LanguageModal',
    refs: [...Modal.config.refs, 'languages', 'loader', 'select[]', 'form'],
    options: {
      styles: {
        type: Object,
        /**
         * @returns {ModalStylesOption}
         */
        default: () => ({
          modal: {
            closed: {
              opacity: '0',
              pointerEvents: 'none',
            },
            open: {
              opacity: '1',
              pointerEvents: 'auto',
            },
            active: 'transition duration-500 ease-out-expo',
          },
          overlay: {
            closed: 'opacity-0',
          },
          container: {
            closed: 'transform scale-95 opacity-0',
            active: 'transition duration-500 ease-out-expo',
          },
        }),
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (this.$refs.select.length > 0) {
      this.languages = this.$refs.select[1];
    }

    // Remove country parameter from URL once mounted
    this.removeCountryParam();

    super.mounted();
  }

  /**
   * Handle select item click
   */
  onSelectChange() {
    this.$refs.loader.classList.remove('opacity-0');
    this.$refs.form.submit();
  }

  /**
   * open
   */
  open() {
    // document.scrollingElement.classList.add('is-search-open');
    super.open();
  }

  /**
   * close
   */
  close() {
    // document.scrollingElement.classList.remove('is-search-open');
    super.close();
  }

  /**
   * Remove country parameter from URL
   */
  removeCountryParam() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('country')) {
      url.searchParams.delete('country');
      window.history.replaceState({}, '', url.toString());
    }
  }
}
